import * as React from 'react'

import { TextButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useContactSupportLink } from './useContactSupportLink'

export interface IContactSupportLinkProps {
  children?: React.ReactNode
}

export const ContactSupportLink = ({ children }: IContactSupportLinkProps) => {
  const intl = useProcurifyIntl()
  const {
    states: { isIntercomEnabled },
    commands: { openNewIntercomMessage },
  } = useContactSupportLink()

  // If custom children are provided, render just the link i.e. to provide your own text
  if (children) {
    return isIntercomEnabled ? (
      <TextButton onClick={openNewIntercomMessage}>{children}</TextButton>
    ) : (
      <a href='mailto:support@procurify.com'>{children}</a>
    )
  }

  return (
    <>
      {intl.formatMessage(messages.contactSupportLinkText, {
        a: (text: string) =>
          isIntercomEnabled ? (
            <TextButton onClick={openNewIntercomMessage}>{text}</TextButton>
          ) : (
            <a href='mailto:support@procurify.com'>{text}</a>
          ),
      })}
    </>
  )
}
